import type { FilterOption } from 'types/capi/plp';

import CloseIcon from '~/assets/icons/Close';
import Pill from '~/components/Pill';
import useSortInteraction from '~/hooks/useSortInteraction';
import gtm from '~/services/gtm.client';

type Props = {
  options: FilterOption[];
};

const FilterOptions = ({ options }: Props) => {
  const fireSortInteraction = useSortInteraction();

  const [unfilteredOption, ...selectableOptions] = options;

  function onClick(item: FilterOption) {
    gtm.sendPlpProductFilterEvent({
      filterName: item.text,
      filterValue: item.text,
      pagePosition: 'Top Bar'
    });

    fireSortInteraction(item.sort_key, 'filter_bar');
  }

  if (!unfilteredOption) return null;

  return selectableOptions.map((item) => {
    const target = item.active ? unfilteredOption : item;

    return (
      <Pill
        active={item.active}
        key={item.path}
        onClick={() => onClick(target)}
        rel="nofollow"
        to={target.path}
      >
        {item.text}
        {item.active ? <CloseIcon height="8" stroke="white" width="8" /> : null}
      </Pill>
    );
  });
};

export default FilterOptions;
